// Draft claims: a facility's new claim starts as a draft (status 2) that only
// the facility can see. The facility submits it for vetting (status -> pending),
// and can take it back to draft until vetting/verification has started.
//
// Used by SingleClaim.vue; expects `user`, `claimdetails`, `singleclaim` and
// `getClaim()` on the component.
export const CLAIM_STATUS_DRAFT = 2;

export default {
  data() {
    return {
      draftBusy: false,
    };
  },

  computed: {
    isFacilityUser() {
      return !!this.user && (this.user.type == "provider" || this.user.type == "provider_employee");
    },

    isDraftClaim() {
      return !!this.claimdetails && this.claimdetails.status !== null && Number(this.claimdetails.status) === CLAIM_STATUS_DRAFT;
    },

    // Mirrors Claims::draftBlockedReason() on the backend, which has the final say.
    canReturnToDraft() {
      const claim = this.claimdetails;
      if (!claim || this.isDraftClaim) return false;
      if (claim.status !== null && claim.status !== undefined && Number(claim.status) !== 0) return false;
      if (claim.checked_by_id || claim.verified_by_id || claim.approved_by_id) return false;
      if (claim.paymentorders && claim.paymentorders.length) return false;

      const services = (this.singleclaim && this.singleclaim.services) || [];
      return !services.some((s) => s.vetted_price != null || s.verified_price != null);
    },
  },

  methods: {
    submitDraftClaim() {
      if (!confirm("Submit this claim for vetting? The agency will be able to see and vet it.")) return;
      this.changeDraftState("submit", "Claim submitted for vetting");
    },

    returnClaimToDraft() {
      if (!confirm("Move this claim back to draft? The agency will not see it until you submit it again.")) return;
      this.changeDraftState("draft", "Claim moved back to draft");
    },

    changeDraftState(action, successMessage) {
      this.draftBusy = true;
      this.axios
        .post(`/api/v1/auth/claims/${this.claimdetails.id}/${action}`)
        .then((response) => {
          this.$toasted.success((response.data && response.data.message) || successMessage, { position: "top-center", duration: 3000 });
          this.getClaim();
        })
        .catch((error) => {
          const message = (error.response && error.response.data && error.response.data.message) || "Something went wrong. Please try again.";
          this.$toasted.error(message, { position: "top-center", duration: 4000 });
        })
        .finally(() => {
          this.draftBusy = false;
        });
    },
  },
};
